import React, { useState, useEffect } from 'react'
import HeroSection from './Components/HeroSection/HeroSection'
import EnterEmailSection from '../../Components/UIKit/EnterEmailSection/EnterEmailSection'
import TopFooter from '../../Components/UIKit/TopFooter/TopFooter'
import WhyChooseZenit from './Components/WhyChooseZenit/WhyChooseZenit'
import HowItWorks from './Components/HowItWorks/HowItWorks'

import Loader from '../../Components/Advanced/Loader/Loader'
//
import { useLocation } from 'react-router-dom'
import getPageTitle from '../../Components/Advanced/Router/Utility'

const SwapView = () => {
  const [loading, setLoading] = useState(true)
  const { pathname } = useLocation()

  if (loading) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'unset'
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = getPageTitle(pathname)
    setTimeout(() => {
      setLoading(false)
    }, 2100)
  }, [])
  return (
    <>
      {loading && (
        <div>
          <Loader />
        </div>
      )}
      <HeroSection />
      <WhyChooseZenit />
      <HowItWorks />
      {/* <EnterEmailSection /> */}
      <TopFooter />
    </>
  )
}

export default SwapView
